export const CIQUAL_SOURCE_NOTE = 'Source: Anses 2025, Table des aliments moyens Ciqual 2025. Reference recommandee: "Anses. 2025. Table des aliments moyens Ciqual 2025, https://doi.org/10.57745/XOJCLN". Donnees utilisees ici a visee informative et educative.';

const PROFILE_BY_KEY = {
  fruit: { calories: 52, proteines: 0.8, glucides: 12, sucres: 10, fibres: 2.4, lipides: 0.3, graisses_saturees: 0.05, sodium: 0.002, indice_glycemique: 45, omega3: 0.02 },
  vegetable: { calories: 30, proteines: 1.8, glucides: 4.5, sucres: 2.5, fibres: 2.8, lipides: 0.3, graisses_saturees: 0.04, sodium: 0.02, indice_glycemique: 20, omega3: 0.03 },
  legume: { calories: 130, proteines: 8.8, glucides: 18, sucres: 2.5, fibres: 7.3, lipides: 2.2, graisses_saturees: 0.3, sodium: 0.008, indice_glycemique: 32, omega3: 0.08 },
  cereal: { calories: 345, proteines: 11, glucides: 62, sucres: 2.2, fibres: 8.4, lipides: 3.4, graisses_saturees: 0.6, sodium: 0.015, indice_glycemique: 56, omega3: 0.06 },
  nut: { calories: 612, proteines: 18.5, glucides: 10.2, sucres: 3.9, fibres: 8.7, lipides: 53, graisses_saturees: 6.1, sodium: 0.004, indice_glycemique: 18, omega3: 0.7 },
  dairyLight: { calories: 64, proteines: 7.3, glucides: 4.3, sucres: 4.1, fibres: 0, lipides: 1.7, graisses_saturees: 1.1, sodium: 0.06, indice_glycemique: 34, omega3: 0.03 },
  dairyCheese: { calories: 320, proteines: 22, glucides: 1.8, sucres: 1.1, fibres: 0, lipides: 25, graisses_saturees: 16, sodium: 0.63, indice_glycemique: 0, omega3: 0.1 },
  egg: { calories: 143, proteines: 12.6, glucides: 0.7, sucres: 0.7, fibres: 0, lipides: 9.5, graisses_saturees: 3.1, sodium: 0.14, indice_glycemique: 0, omega3: 0.07 },
  fish: { calories: 174, proteines: 22.8, glucides: 0, sucres: 0, fibres: 0, lipides: 8.4, graisses_saturees: 2.1, sodium: 0.09, indice_glycemique: 0, omega3: 1.1 },
  meat: { calories: 170, proteines: 24.5, glucides: 0, sucres: 0, fibres: 0, lipides: 7.4, graisses_saturees: 2.4, sodium: 0.08, indice_glycemique: 0, omega3: 0.05 },
};

const FOOD_SECTIONS = [
  {
    category: 'fruits_legumes',
    profile: 'fruit',
    unite: 'kg',
    seuil: 1,
    storage: 'fridge',
    tags: ['vegan', 'fridge'],
    names: [
      'Pomme', 'Banane', 'Poire', 'Orange', 'Clementine', 'Mandarine', 'Citron', 'Pamplemousse', 'Pomelo', 'Kiwi', 'Fraise',
      'Framboise', 'Myrtille', 'Mure', 'Cassis', 'Groseille', 'Cerise', 'Raisin noir', 'Raisin blanc', 'Prune', 'Mirabelle',
      'Quetsche', 'Abricot', 'Peche', 'Nectarine', 'Mangue', 'Papaye', 'Ananas', 'Melon', 'Pasteque', 'Grenade', 'Figue',
      'Datte', 'Kaki', 'Litchi', 'Goyave', 'Fruit de la passion', 'Canneberge', 'Airelle', 'Kumquat', 'Carambole', 'Coing',
      'Noix de coco', 'Avocat', 'Pruneau sec', 'Figue sechee', 'Raisin sec', 'Sureau', 'Physalis', 'Fruit du dragon', 'Mangoustan',
      'Pomme granny', 'Pomme golden', 'Poire conference', 'Clafoutis de cerise sans sucre ajoute (fruit)', 'Compote de pomme sans sucre (fruit)',
      'Puree de mangue sans sucre (fruit)', 'Pulpe de fruit rouge (fruit)', 'Citron vert', 'Yuzu', 'Baie de goji', 'Mure blanche',
      'Nashi', 'Pitaya jaune', 'Pamplemousse rose', 'Prune rouge', 'Fraise des bois', 'Framboise jaune', 'Anone', 'Longane'
    ],
  },
  {
    category: 'fruits_legumes',
    profile: 'vegetable',
    unite: 'kg',
    seuil: 0.6,
    storage: 'fridge',
    tags: ['vegan', 'fridge', 'lowCarb'],
    names: [
      'Tomate', 'Tomate cerise', 'Carotte', 'Concombre', 'Courgette', 'Aubergine', 'Poivron rouge', 'Poivron vert', 'Poivron jaune',
      'Brocoli', 'Chou-fleur', 'Chou blanc', 'Chou rouge', 'Chou kale', 'Chou de Bruxelles', 'Epinards', 'Laitue', 'Laitue romaine',
      'Mache', 'Roquette', 'Cresson', 'Endive', 'Blette', 'Betterave', 'Radis', 'Navet', 'Panais', 'Celeri branche', 'Celeri rave',
      'Poireau', 'Oignon', 'Oignon rouge', 'Oignon blanc', 'Echalote', 'Ail', 'Fenouil', 'Asperge verte', 'Asperge blanche',
      'Haricot vert', 'Petit pois', 'Artichaut', 'Champignon de Paris', 'Pleurote', 'Shiitake', 'Patate douce', 'Pomme de terre',
      'Topinambour', 'Butternut', 'Potimarron', 'Courge musquee', 'Courge spaghetti', 'Mais doux', 'Manioc', 'Igname', 'Gombo',
      'Pak choi', 'Chou-rave', 'Raifort', 'Okra', 'Epinard jeune pousse', 'Poireau surgele', 'Brocoli surgele', 'Epinard surgele',
      'Haricot vert surgele', 'Petit pois surgeles', 'Carotte rapee', 'Concombre mini', 'Tomate ancienne', 'Courge patidou',
      'Navet boule d or', 'Chou chinois', 'Laitue iceberg', 'Radis noir', 'Poivron orange', 'Panais surgele', 'Patate douce violette',
      'Coriandre fraiche', 'Persil frais', 'Aneth frais', 'Basilic frais', 'Ciboulette fraiche', 'Menthe fraiche', 'Oseille',
      'Salicorne', 'Fenouil bulbe', 'Celeri feuille', 'Blette rouge', 'Poireau primeur'
    ],
  },
  {
    category: 'alimentation',
    profile: 'legume',
    unite: 'kg',
    seuil: 0.5,
    storage: 'ambient',
    tags: ['vegan', 'protein'],
    names: [
      'Lentilles vertes', 'Lentilles corail', 'Lentilles blondes', 'Pois chiches', 'Pois casses', 'Haricots rouges', 'Haricots noirs',
      'Haricots blancs', 'Haricots coco', 'Feveroles', 'Faves', 'Soja jaune', 'Edamame', 'Azukis', 'Pois du cap',
      'Lupin', 'Mungo', 'Pois chiches en conserve', 'Lentilles cuites', 'Haricots rouges cuits', 'Haricots blancs cuits',
      'Pois casses cuits', 'Falafel sec (legumineuse)', 'Tofu nature', 'Tempeh nature', 'Proteine de soja texturee',
      'Houmous nature', 'Puree de pois chiches', 'Puree de lentilles', 'Farine de pois chiche', 'Farine de lentilles'
    ],
  },
  {
    category: 'alimentation',
    profile: 'cereal',
    unite: 'kg',
    seuil: 0.6,
    storage: 'ambient',
    tags: ['vegan'],
    names: [
      'Avoine flocons', 'Riz complet', 'Riz basmati', 'Riz blanc', 'Quinoa', 'Boulgour', 'Orge perle', 'Millet', 'Sarrasin',
      'Semoule de ble dur', 'Pates completes', 'Pates blanches', 'Pain complet', 'Pain de seigle', 'Pain integral',
      'Farine de ble complet', 'Farine d avoine', 'Farine de seigle', 'Farine de sarrasin', 'Amarante', 'Epeautre', 'Seigle',
      'Ble concasse', 'Couscous complet', 'Polenta', 'Son d avoine', 'Son de ble', 'Flocons d orge', 'Flocons de seigle',
      'Muesli sans sucre ajoute', 'Granola nature', 'Galette de riz', 'Galette de mais', 'Crackers complets', 'Porridge nature'
    ],
  },
  {
    category: 'fruits_legumes',
    profile: 'nut',
    unite: 'kg',
    seuil: 0.25,
    storage: 'ambient',
    tags: ['vegan', 'protein', 'lowCarb'],
    names: [
      'Amandes', 'Noix', 'Noisettes', 'Pistaches', 'Noix de cajou', 'Noix de pecan', 'Noix du Bresil', 'Noix de macadamia',
      'Pignons de pin', 'Cacahuetes nature', 'Graines de chia', 'Graines de lin', 'Graines de courge', 'Graines de tournesol',
      'Graines de sesame', 'Tahin', 'Beurre d amande', 'Beurre de cacahuete 100%', 'Melange de noix nature', 'Chia moulu',
      'Lin moulu', 'Graines de chanvre', 'Graines de pavot', 'Coco rapee', 'Noix de kola alimentaire'
    ],
  },
  {
    category: 'laitier',
    profile: 'dairyLight',
    unite: 'pieces',
    seuil: 3,
    storage: 'fridge',
    tags: ['protein', 'fridge'],
    names: [
      'Yaourt nature', 'Yaourt grec nature', 'Skyr nature', 'Fromage blanc', 'Petit suisse nature', 'Faisselle', 'Kefir nature',
      'Lait demi ecreme', 'Lait ecreme', 'Lait entier', 'Lait sans lactose', 'Lait de chevre', 'Lait de brebis', 'Ricotta',
      'Cottage cheese', 'Mozzarella', 'Feta', 'Chevre frais', 'Fromage frais', 'Yaourt de chevre nature', 'Yaourt brebis nature',
      'Boisson proteinee lactee nature', 'Creme fraiche legere', 'Beurre doux', 'Beurre demi-sel', 'Lait fermente nature',
      'Laban nature', 'Babeurre', 'Lait ribot', 'Fromage blanc 0%'
    ],
  },
  {
    category: 'laitier',
    profile: 'dairyCheese',
    unite: 'pieces',
    seuil: 2,
    storage: 'fridge',
    tags: ['protein', 'fridge', 'lowCarb'],
    names: [
      'Emmental', 'Comte', 'Parmesan', 'Gruyere', 'Cheddar', 'Gouda', 'Brie', 'Camembert', 'Cantal', 'Mimolette', 'Tomme',
      'Roquefort', 'Bleu', 'Reblochon', 'Saint-nectaire', 'Raclette', 'Fromage de brebis affine', 'Fromage de chevre affine',
      'Halloumi', 'Scamorza'
    ],
  },
  {
    category: 'laitier',
    profile: 'egg',
    unite: 'pieces',
    seuil: 6,
    storage: 'fridge',
    tags: ['protein', 'lowCarb', 'fridge'],
    names: ['Oeufs', 'Blanc d oeuf liquide', 'Jaune d oeuf'],
  },
  {
    category: 'alimentation',
    profile: 'fish',
    unite: 'kg',
    seuil: 0.4,
    storage: 'freezer',
    tags: ['protein', 'freezer', 'lowCarb'],
    names: [
      'Saumon', 'Truite', 'Thon', 'Maquereau', 'Sardine', 'Anchois', 'Cabillaud', 'Merlu', 'Colin', 'Lieu noir', 'Sole',
      'Dorade', 'Bar', 'Haddock', 'Seiche', 'Calamar', 'Crevette', 'Moule', 'Palourde', 'Saint-jacques', 'Saumon surgele',
      'Thon naturel en conserve', 'Sardine nature en conserve', 'Maquereau au naturel', 'Crevettes surgelees'
    ],
  },
  {
    category: 'alimentation',
    profile: 'meat',
    unite: 'kg',
    seuil: 0.4,
    storage: 'freezer',
    tags: ['protein', 'freezer', 'lowCarb'],
    names: [
      'Poulet blanc', 'Escalope de dinde', 'Boeuf maigre', 'Steak hache 5%', 'Veau', 'Agneau maigre', 'Canard maigre',
      'Lapin', 'Foie de volaille', 'Foie de boeuf', 'Blanc de poulet surgele', 'Emince de dinde', 'Boeuf hache maigre',
      'Emince de veau', 'Cuisse de poulet sans peau'
    ],
  },
];

function stripAccents(text) {
  return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function hashName(name) {
  const text = stripAccents(name).toLowerCase();
  let h = 0;
  for (let i = 0; i < text.length; i += 1) {
    h = ((h << 5) - h) + text.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

function vary(baseValue, name, amplitude = 0.12, min = 0) {
  const h = hashName(name);
  const ratio = ((h % 1000) / 1000) * 2 - 1;
  const next = baseValue * (1 + ratio * amplitude);
  return Math.max(min, Number(next.toFixed(2)));
}

function buildNutrition(profileKey, name) {
  const base = PROFILE_BY_KEY[profileKey] || PROFILE_BY_KEY.vegetable;
  return {
    calories: Math.round(vary(base.calories, `${name}:cal`, 0.15, 0)),
    proteines: vary(base.proteines, `${name}:pro`, 0.2, 0),
    glucides: vary(base.glucides, `${name}:carb`, 0.2, 0),
    sucres: vary(base.sucres, `${name}:sugar`, 0.25, 0),
    fibres: vary(base.fibres, `${name}:fiber`, 0.25, 0),
    lipides: vary(base.lipides, `${name}:fat`, 0.2, 0),
    graisses_saturees: vary(base.graisses_saturees, `${name}:sat`, 0.2, 0),
    sodium: vary(base.sodium, `${name}:sodium`, 0.25, 0),
    indice_glycemique: Math.round(vary(base.indice_glycemique, `${name}:gi`, 0.2, 0)),
    omega3: vary(base.omega3, `${name}:o3`, 0.3, 0),
  };
}

function buildEducation(spec) {
  const profile = spec.profile;
  const isProtein = spec.tags.includes('protein');
  const isLowCarb = spec.tags.includes('lowCarb');

  const byProfile = {
    fruit: {
      family: 'fruit (proche des categories CIQUAL fruits crus / compotes / fruits seches selon preparation)',
      usages: 'Ideal en collation, salade de fruits, petit-dejeuner, smoothie ou compote.',
      recettes: [`Salade de ${spec.nom}`, `${spec.nom} au yaourt nature`, `Compote express de ${spec.nom}`],
      choix: 'Choisir un fruit ferme, parfume et adapte au niveau de maturite recherche.',
      conservation: 'Conserver au frais pour ralentir la maturation, sauf fruits a noyau encore fermes.',
      duree: '2 a 7 jours en general selon maturite et type de fruit.',
      risque: 'Surveiller la portion pour les fruits tres sucres; attention aux allergies croisees pollens/fruits.',
    },
    vegetable: {
      family: 'legume (proche des categories CIQUAL legumes crus/cuits)',
      usages: 'Ideal en crudites, poelee, vapeur, wok, gratin ou soupe de legumes.',
      recettes: [`Poelee de ${spec.nom}`, `${spec.nom} vapeur assaisonne`, `${spec.nom} en soupe de legumes`],
      choix: 'Choisir un legume ferme, sans taches ni ramollissement.',
      conservation: 'Conserver au refrigerateur dans le bac legumes, sans lavage prealable.',
      duree: '3 a 10 jours selon le legume et son etat de fraicheur.',
      risque: 'Laver soigneusement avant consommation, surtout si consomme cru.',
    },
    legume: {
      family: 'legumineuse (proche des categories CIQUAL legumineuses seches/fraiches/cuites)',
      usages: 'Ideal en salade, curry, dahl, puree ou accompagnement riche en fibres.',
      recettes: [`Salade de ${spec.nom}`, `${spec.nom} mijote`, `${spec.nom} en puree`],
      choix: 'Choisir des grains entiers et homogènes; rincer avant cuisson.',
      conservation: 'Conserver au sec et a l abri de l humidite; versions cuites au frais apres ouverture.',
      duree: 'Plusieurs mois au sec; 2 a 4 jours au frais une fois cuit.',
      risque: 'Introduire progressivement en cas de sensibilite digestive.',
    },
    cereal: {
      family: 'produit cerealier (proche des categories CIQUAL pates/riz/cereales/pains)',
      usages: 'Ideal en accompagnement, salade composee, porridge ou base de bowl.',
      recettes: [`Bol de ${spec.nom}`, `${spec.nom} facon pilaf`, `Salade de ${spec.nom}`],
      choix: 'Privilegier les versions peu raffinees et peu salees quand possible.',
      conservation: 'Conserver au sec dans un contenant hermetique.',
      duree: 'Plusieurs mois au sec selon DLC/DDM.',
      risque: 'Verifier les allergenes (gluten) selon la cereale.',
    },
    nut: {
      family: 'fruit a coque / graine oleagineuse (proche des categories CIQUAL fruits a coque et graines)',
      usages: 'Ideal en topping, collation, ajout dans salades ou yaourts.',
      recettes: [`Melange ${spec.nom} + fruit`, `${spec.nom} en topping`, `Pate tartinable a base de ${spec.nom}`],
      choix: 'Privilegier les versions nature non salees et non sucrees.',
      conservation: 'Conserver a l abri de la chaleur et de la lumiere, de preference en bocal.',
      duree: '1 a 6 mois selon le produit et les conditions de stockage.',
      risque: 'Allergenes frequents; portions a moderer du fait de la densite energetique.',
    },
    dairyLight: {
      family: 'produit laitier frais',
      usages: 'Ideal au petit-dejeuner, en collation ou en sauce froide.',
      recettes: [`Bol de ${spec.nom} + fruits`, `${spec.nom} en sauce yaourt`, `${spec.nom} avec flocons d avoine`],
      choix: 'Comparer teneur en sucres ajoutes et en matieres grasses selon objectif.',
      conservation: 'Conserver au refrigerateur et refermer apres ouverture.',
      duree: 'Quelques jours apres ouverture selon indication emballage.',
      risque: 'Attention au lactose selon tolerance individuelle.',
    },
    dairyCheese: {
      family: 'fromage affine',
      usages: 'Ideal en assaisonnement, gratin, sandwich ou plateau.',
      recettes: [`Tartine ${spec.nom}`, `${spec.nom} dans un gratin`, `Salade avec ${spec.nom}`],
      choix: 'Adapter le type de fromage a la teneur en sel et graisses recherchee.',
      conservation: 'Conserver au refrigerateur dans son emballage ou papier fromage.',
      duree: 'Quelques jours a quelques semaines selon type et affinage.',
      risque: 'Portions a moderer en cas de regime pauvre en sel ou en graisses saturees.',
    },
    egg: {
      family: 'oeuf et ovoproduits',
      usages: 'Ideal en omelette, oeuf dur, brouille ou preparation culinaire.',
      recettes: [`Omelette ${spec.nom}`, `${spec.nom} brouille`, `${spec.nom} dur en salade`],
      choix: 'Verifier la coquille intacte et la date de consommation recommandee.',
      conservation: 'Conserver au frais, sans variation thermique importante.',
      duree: 'Jusqu a la date indiquee; preparations a base d oeuf a consommer rapidement.',
      risque: 'Cuisson suffisante recommandee pour personnes fragiles (grossesse, immunodepression).',
    },
    fish: {
      family: 'poisson / fruits de mer',
      usages: 'Ideal au four, vapeur, poelee douce ou court-bouillon.',
      recettes: [`${spec.nom} au four`, `${spec.nom} poele citron`, `${spec.nom} vapeur herbes`],
      choix: 'Verifier l odeur, la fermete et le respect de la chaine du froid.',
      conservation: 'Conserver au refrigerateur tres court terme ou congeler rapidement.',
      duree: '24-48 h au frais en general, plusieurs semaines/mois au congelateur.',
      risque: 'Bien cuire selon public sensible; attention aux aretes/allergenes.',
    },
    meat: {
      family: 'viande',
      usages: 'Ideal grillee, poelee, mijotee ou au four selon coupe.',
      recettes: [`${spec.nom} poele`, `${spec.nom} mijote`, `${spec.nom} au four`],
      choix: 'Privilegier une viande fraiche, peu grasse, avec origine tracee.',
      conservation: 'Conserver au refrigerateur et separer des aliments prets a consommer.',
      duree: '24-72 h au frais selon type; plus long si congele.',
      risque: 'Respecter les temperatures de cuisson et l hygiene de manipulation.',
    },
  };

  const selected = byProfile[profile] || byProfile.vegetable;

  return {
    description: `${spec.nom} est classe dans la famille ${selected.family}.`,
    utiliteNutritionnelle: isProtein
      ? 'Apporte des proteines utiles a la satiete et au maintien de la masse musculaire.'
      : 'Contribue aux apports en energie, fibres et micronutriments selon la portion consommee.',
    origine: 'Profil base sur la taxonomie CIQUAL (groupe/sous-groupe alimentaire) et usage culinaire courant.',
    interetsSante: isLowCarb
      ? 'Peut etre pertinent dans une strategie de reduction des glucides selon votre contexte personnel.'
      : 'Peut s integrer dans une alimentation equilibree avec variete et portions adaptees.',
    risquesPrecautions: selected.risque,
    conservation: selected.conservation,
    dureeConservation: selected.duree,
    choixProduit: selected.choix,
    usages: selected.usages,
    recettesRapides: selected.recettes,
    remarques: 'Les valeurs nutritionnelles restent des moyennes indicatives; elles varient selon variete, marque et preparation.',
    aSavoir: isLowCarb
      ? 'Ajuster portions et accompagnements selon vos objectifs glucidiques.'
      : 'La regularite et la diversite alimentaire comptent plus qu un aliment isole.',
  };
}

function makeFoodObject(spec) {
  return {
    nom: spec.nom,
    categorie: spec.categorie,
    unite: spec.unite,
    seuil: spec.seuil,
    storage: spec.storage,
    tags: spec.tags,
    nutrition100g: buildNutrition(spec.profile, spec.nom),
    ...buildEducation(spec),
  };
}

function buildAllFoods() {
  const all = [];

  FOOD_SECTIONS.forEach((section) => {
    section.names.forEach((name) => {
      all.push(makeFoodObject({
        nom: name,
        categorie: section.category,
        unite: section.unite,
        seuil: section.seuil,
        storage: section.storage,
        tags: [...section.tags],
        profile: section.profile,
      }));
    });
  });

  // Deduplicate by normalized name while preserving first occurrence.
  const seen = new Set();
  const unique = [];
  all.forEach((item) => {
    const key = stripAccents(item.nom).trim().toLowerCase();
    if (!seen.has(key)) {
      seen.add(key);
      unique.push(item);
    }
  });

  return unique;
}

export const CIQUAL_ESSENTIAL_FOODS = buildAllFoods();

function normalizeName(name) {
  return stripAccents(String(name || '').trim().toLowerCase());
}

export function findCiqualFoodByName(name) {
  const target = normalizeName(name);
  if (!target) return null;

  const exact = CIQUAL_ESSENTIAL_FOODS.find((food) => normalizeName(food.nom) === target);
  if (exact) return exact;

  // Flexible fallback for close match (e.g. plurals/extra qualifiers).
  return CIQUAL_ESSENTIAL_FOODS.find((food) => {
    const current = normalizeName(food.nom);
    return current.includes(target) || target.includes(current);
  }) || null;
}
